  <button
    kendoPopoverAnchor
    [popover]="userPopover"
    [showOn]="'click'"
    type="button"
    class="user-menu__current-user"
    aria-haspopup="menu"
    aria-expanded="false"
  >
    {{ (authService.user$ | async)?.name }}
  </button>

  <!-- The Popover itself -->
  <kendo-popover
    #userPopover
    class="popup-bottom rc-popover-tight"
    [position]="'bottom'"
    [callout]="false"
    [offset]="12"
    [animation]="false"
  >
    <ng-template kendoPopoverTitleTemplate>
      <span class="user-menu__header">{{ (authService.user$ | async)?.name }}</span>
    </ng-template>


    <!-- Body = your menu -->
    <ng-template kendoPopoverBodyTemplate>
      <ul class="rc-popover  rc-popover-tight user-menu__dropdown" role="menu">
        @for (menuItem of menuItems; track menuItem) {
          <li
            role="menuitem"
            tabindex="0"
            (keydown.enter)="menuItem.clickAction()"
            (click)="menuItem.clickAction()"
            class="user-menu__item"
          >
            @if (menuItem.icon) {
              <i class="menu-icon" [class]="menuItem.icon" aria-hidden="true"></i>
            }
            <span class="menu-text">
            {{ menuItem.text | translate | capitalize }}
          </span>
          </li>
        }
      </ul>
    </ng-template>
  </kendo-popover>
